export default "__VITE_ASSET__BnggCsGN__"